<template>
    <div
        class="rounded-lg shadow-lg flex items-center justify-center py-2 px-4 h-16 animate-pulse bg-grey-100"
    >
        <FontAwesomeIcon :icon="['fas', 'tire']"
                         class="text-grey-200 animate-spin"></FontAwesomeIcon>
    </div>
</template>

<script>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    name: "BrandImageLoader",
    components: {FontAwesomeIcon}
};
</script>

<style scoped>

</style>
